import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Error } from '@mui/icons-material';
import { Typography } from '@totalsoft/rocket-ui';
import { ErrorIconWrapper } from './OfferAssetClientStyles';

const OfferAssetClientSummary = ({ clientDataSummary, isClientLoaded }) => {
  const { t } = useTranslation();

  return (
    <>
      {clientDataSummary.hasPartnerType || !isClientLoaded ? (
        <Grid container alignItems='center' spacing={1}>
          <Grid item xs={12} lg={4} display='flex' gap={1}>
            <strong>{t('OfferEdit.Client.Title')}:</strong>
            <Typography id={'offerAssetClientCard_summary_name'}>{clientDataSummary.partnerName}</Typography>
          </Grid>
          <Grid item xs={12} lg={4} display='flex' gap={1}>
            <strong>{t('OfferEdit.Client.MobilePhone')}:</strong>
            <Typography id={'offerAssetClientCard_summary_mobilePhone'}>{clientDataSummary.contactData.phone}</Typography>
          </Grid>
          <Grid item xs={12} lg={4} display='flex' gap={1}>
            <strong>{t('OfferEdit.Client.Email')}:</strong>
            <Typography id={'offerAssetClientCard_summary_email'}>{clientDataSummary.contactData.email}</Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <ErrorIconWrapper item container alignItems='center'>
            <Error fontSize='small' color='error' />
          </ErrorIconWrapper>
          <Grid item>
            <Typography color='error' emphasis='bold'>
              {t('OfferEdit.Client.MissingClientType')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

OfferAssetClientSummary.propTypes = {
  clientDataSummary: PropTypes.object.isRequired,
  isClientLoaded: PropTypes.bool.isRequired
};

export default OfferAssetClientSummary;
